var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_94768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11L14.8447 18.3787C14.9236 18.6943 14.6849 19 14.3596 19H9.64039C9.3151 19 9.07642 18.6943 9.15532 18.3787L11 11M13 11H11M13 11V11C13.5523 11 14 10.5523 14 10V8C14 7.44772 13.5523 7 13 7V7H11V7C10.4477 7 10 7.44772 10 8V10C10 10.5523 10.4477 11 11 11V11",
    stroke: "#9DA1B5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8284 11.8279C17.1999 11.4565 17.4945 11.0155 17.6955 10.5302C17.8965 10.0449 18 9.52479 18 8.99951C18 8.47422 17.8965 7.95407 17.6955 7.46877C17.4945 6.98347 17.1999 6.54251 16.8284 6.17108",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17157 11.8279C6.80014 11.4565 6.5055 11.0155 6.30448 10.5302C6.10346 10.0449 6 9.52479 6 8.99951C6 8.47422 6.10346 7.95407 6.30448 7.46877C6.5055 6.98347 6.80014 6.54251 7.17157 6.17108",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9497 13.9492C19.5998 13.2992 20.1154 12.5275 20.4672 11.6783C20.8189 10.829 21 9.91872 21 8.99947C21 8.08022 20.8189 7.16997 20.4672 6.32069C20.1154 5.47141 19.5998 4.69973 18.9497 4.04972",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05025 13.9492C4.40024 13.2992 3.88463 12.5275 3.53284 11.6783C3.18106 10.829 3 9.91872 3 8.99947C3 8.08022 3.18106 7.16997 3.53284 6.32069C3.88463 5.47141 4.40024 4.69973 5.05025 4.04972",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_94768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTower);
export default __webpack_public_path__ + "static/media/menuTower.e59c2881722082bb7ad59d0a57385859.svg";
export { ForwardRef as ReactComponent };